export enum ResultStatusEnum {
  PendingReview = 'pending_review',
  Completed = 'completed',
}
